var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6.012c-.245.015-.42.049-.567.124a1.25 1.25 0 0 0-.547.546C3.5 6.95 3.5 7.3 3.5 8v2.6c0 .84 0 1.26.163 1.58a1.5 1.5 0 0 0 .656.656c.32.164.74.164 1.581.164h4.2c.84 0 1.26 0 1.581-.164a1.5 1.5 0 0 0 .655-.655c.164-.32.164-.741.164-1.581V8c0-.7 0-1.05-.136-1.318a1.25 1.25 0 0 0-.546-.546c-.149-.075-.323-.11-.568-.124V4.75a3.25 3.25 0 1 0-6.5 0v1.262ZM6 6h4V4.75a2 2 0 1 0-4 0V6Z"
  })));
};
export default SvgLock;